import { Header as BaseHeader } from "@partners/ui";

import { HeaderLogo } from "../HeaderLogo";

export const UnauthenticatedHeader = () => (
  <BaseHeader leftElement={<HeaderLogo />} />
);
